<template>
    <div class="row child-component">
        <div class="col-lg-7 col-md-8 col-sm-8 col-xs-6 mx-auto">
            <div class="d-block row col-lg-8 mx-auto">
                <div class="fieldborder mt-2">
                    <label>Legal Entity</label>
                    <OmniSelect class="" placeholder="Select Legal Entity" name="Entity"
                    :showLabel="false" label="value" v-model="ReportingEntity.LegalEntity" :options="EntityList"></OmniSelect>
                </div>
                <div class="fieldborder mt-2">
                    <label>AGENCY </label>
                    <OmniSelect placeholder="Select Agency" name="Agency" :showLabel="false" label="Select Agency"
                        :options="AgencyList" v-model="ReportingEntity.Agency" />
                </div>
                <div class="fieldborder pt-2">
                    <label>Location
                        <svg style="margin-bottom: 1px; margin-left: 5px" width="9px" height="9px" viewBox="0 0 9 9"
                            version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                            v-b-tooltip.hover.v-dark.right.html="'Eg: NY01- New York; CA03-Burbank Ca'
                                ">
                            <g id="LATEST" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                <path
                                    d="M4.5,0 C2.014875,0 0,2.014875 0,4.5 C0,6.985125 2.014875,9 4.5,9 C6.985125,9 9,6.985125 9,4.5 C8.997375,2.016 6.984,0.002625 4.5,0 Z M4.59375,1.875 C4.90425,1.875 5.15625,2.127 5.15625,2.4375 C5.15625,2.748 4.90425,3 4.59375,3 C4.28325,3 4.03125,2.748 4.03125,2.4375 C4.03125,2.127 4.28325,1.875 4.59375,1.875 Z M5.4375,6.9375 L3.9375,6.9375 C3.7305,6.9375 3.5625,6.7695 3.5625,6.5625 C3.5625,6.3555 3.7305,6.1875 3.9375,6.1875 L4.21875,6.1875 C4.2705,6.1875 4.3125,6.1455 4.3125,6.09375 L4.3125,4.40625 C4.3125,4.3545 4.2705,4.3125 4.21875,4.3125 L3.9375,4.3125 C3.7305,4.3125 3.5625,4.1445 3.5625,3.9375 C3.5625,3.7305 3.7305,3.5625 3.9375,3.5625 L4.3125,3.5625 C4.726875,3.5625 5.0625,3.898125 5.0625,4.3125 L5.0625,6.09375 C5.0625,6.1455 5.1045,6.1875 5.15625,6.1875 L5.4375,6.1875 C5.6445,6.1875 5.8125,6.3555 5.8125,6.5625 C5.8125,6.7695 5.6445,6.9375 5.4375,6.9375 Z"
                                    id="info" fill="#00A1D2" fill-rule="nonzero"></path>
                            </g>
                        </svg>
                    </label>
                    <b-form-input :maxlength="4" autocomplete="off" id="Location" class="omniipclass" v-model="ReportingEntity.Location" placeholder="Enter Location"></b-form-input>
                </div>
                <div class="fieldborder pt-2">
                    <label>Department
                        <svg style="margin-bottom: 1px; margin-left: 5px" width="9px" height="9px" viewBox="0 0 9 9"
                            version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                            v-b-tooltip.hover.v-dark.right.html="'Eg: 3500-Planning; 1050 GAM Allocations'
                                ">
                            <g id="LATEST" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                <path
                                    d="M4.5,0 C2.014875,0 0,2.014875 0,4.5 C0,6.985125 2.014875,9 4.5,9 C6.985125,9 9,6.985125 9,4.5 C8.997375,2.016 6.984,0.002625 4.5,0 Z M4.59375,1.875 C4.90425,1.875 5.15625,2.127 5.15625,2.4375 C5.15625,2.748 4.90425,3 4.59375,3 C4.28325,3 4.03125,2.748 4.03125,2.4375 C4.03125,2.127 4.28325,1.875 4.59375,1.875 Z M5.4375,6.9375 L3.9375,6.9375 C3.7305,6.9375 3.5625,6.7695 3.5625,6.5625 C3.5625,6.3555 3.7305,6.1875 3.9375,6.1875 L4.21875,6.1875 C4.2705,6.1875 4.3125,6.1455 4.3125,6.09375 L4.3125,4.40625 C4.3125,4.3545 4.2705,4.3125 4.21875,4.3125 L3.9375,4.3125 C3.7305,4.3125 3.5625,4.1445 3.5625,3.9375 C3.5625,3.7305 3.7305,3.5625 3.9375,3.5625 L4.3125,3.5625 C4.726875,3.5625 5.0625,3.898125 5.0625,4.3125 L5.0625,6.09375 C5.0625,6.1455 5.1045,6.1875 5.15625,6.1875 L5.4375,6.1875 C5.6445,6.1875 5.8125,6.3555 5.8125,6.5625 C5.8125,6.7695 5.6445,6.9375 5.4375,6.9375 Z"
                                    id="info" fill="#00A1D2" fill-rule="nonzero"></path>
                            </g>
                        </svg>
                    </label>
                    <the-mask type="text" :tokens="{ '#': { pattern: /\d/ } }" :mask="['##', '####']"
                        style="margin-top:1px;" class="form-control" @focus="ResetDirty(ReportingEntity.Department)"
                        @blur="SetDirty(ReportingEntity.Department)" placeholder="Enter Department" autocomplete="off" id="Department" v-model="ReportingEntity.Department" :maxlength="4"></the-mask>
                </div>
                <div class="fieldborder mt-2">
                    <label>Suggested entity</label>
                    <b-form-input disabled autocomplete="off" id="SuggestedEntity" class="omniipclass" v-model="ReportingEntity.SuggestedEntity" placeholder="Legal Entity-Location-Department"></b-form-input>
                </div>
                <div class="fieldborder mt-2">
                    <label>HFM Entity/Hyperion
                        <svg style="margin-bottom: 1px; margin-left: 5px" width="9px" height="9px" viewBox="0 0 9 9"
                            version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                            v-b-tooltip.hover.v-dark.right.html="'It should be the HFM P&L mapping that the new reporting entity should map to (ex. 5usopera).'
                                ">
                            <g id="LATEST" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                <path
                                    d="M4.5,0 C2.014875,0 0,2.014875 0,4.5 C0,6.985125 2.014875,9 4.5,9 C6.985125,9 9,6.985125 9,4.5 C8.997375,2.016 6.984,0.002625 4.5,0 Z M4.59375,1.875 C4.90425,1.875 5.15625,2.127 5.15625,2.4375 C5.15625,2.748 4.90425,3 4.59375,3 C4.28325,3 4.03125,2.748 4.03125,2.4375 C4.03125,2.127 4.28325,1.875 4.59375,1.875 Z M5.4375,6.9375 L3.9375,6.9375 C3.7305,6.9375 3.5625,6.7695 3.5625,6.5625 C3.5625,6.3555 3.7305,6.1875 3.9375,6.1875 L4.21875,6.1875 C4.2705,6.1875 4.3125,6.1455 4.3125,6.09375 L4.3125,4.40625 C4.3125,4.3545 4.2705,4.3125 4.21875,4.3125 L3.9375,4.3125 C3.7305,4.3125 3.5625,4.1445 3.5625,3.9375 C3.5625,3.7305 3.7305,3.5625 3.9375,3.5625 L4.3125,3.5625 C4.726875,3.5625 5.0625,3.898125 5.0625,4.3125 L5.0625,6.09375 C5.0625,6.1455 5.1045,6.1875 5.15625,6.1875 L5.4375,6.1875 C5.6445,6.1875 5.8125,6.3555 5.8125,6.5625 C5.8125,6.7695 5.6445,6.9375 5.4375,6.9375 Z"
                                    id="info" fill="#00A1D2" fill-rule="nonzero"></path>
                            </g>
                        </svg>
                    </label>
                    <b-form-input autocomplete="off" id="Location" class="omniipclass" v-model="ReportingEntity.HFMEntity" placeholder="Enter HFM Entity/Hyperion"></b-form-input>
                </div>
            </div>
        </div>
        <div class="form-group pt-60 text-right  footer-buttons" style="padding-right:96px !important;">
            <button class="btn btn-link text-uppercase" @click="Cancel()">
                CANCEL
            </button>
            <button class="text-uppercase btn custom-button btn-primary" @click="Next()" :disabled="this.$v.$invalid">
                NEXT
            </button>
        </div>

    </div>
</template>

<script>
import { mapGetters } from "vuex";
import service from "../../services/Dropdowns";
import { required , numeric } from "vuelidate/lib/validators";
import { TheMask } from 'vue-the-mask';
export default {
    components: {
        TheMask
    },
    data() {
        return {
            AgencyList:[],
            EntityList:[],
        }
    },
    props: {
        id: {
            type: Number,
            required: false,
        },
        isDraft: {
            type: Boolean,
            required: false
        }
    },
    validations: {
        ReportingEntity: {
            LegalEntity: {
                required
            },
            Agency: {
                required
            },
            Location: {
                required
            },
            Department: {
                required,
                numeric
            },
            SuggestedEntity: {
                required
            },
            HFMEntity: {
                required
            },
        }
    },
    computed: {
        IsEdit() {
            return this.id && !isNaN(this.id) && parseInt(this.id) > 0 ? true : false;
        },
        ...mapGetters('reportingEntity', {
            ReportingEntity: 'ReportingEntity',
        }),
    },
    mounted() {
        this.LoadDropdownValues();
        if (this.IsEdit) {
            this.GetReportingEntityRequestWithTaskDetails();
        }
    },
    activated() {
        this.$parent.$emit("stepInitiated", this.$route.meta.tabIndex);
    },
    methods: {
        async LoadDropdownValues() {
            service
            .getOriginalEntityRecords("Financial Entity")
            .then((res) => {
                for(var index in res.data) {
                    var entityitem = res.data[index];
                    this.EntityList.push({
                    "label" :  entityitem.label,
                    "value"  : entityitem.value,
                });
            }
                this.EntityList = this.EntityList;
            })
            .catch((err) => {
                alert(err);
            });
        },

        EntityChange(isManualChanges = false){
            var entityid = this.ReportingEntity.LegalEntity;
            if(isManualChanges) {
                this.ReportingEntity.Agency = null;
            }
            service
            .getAgencyDropdownValues(entityid, entityid)
            .then((res) => {
                this.AgencyList=[];
                this.AgencyList=res.data;
                if (this.id > 0) {
                    this.UpdateAgencyName(this.ReportingEntity.Agency)
                }

            }).catch((err) => {
                alert(err);
            });
        },
        UpdateAgencyName(newVal) {
            const agencyValue = this.AgencyList.findIndex((item) => {
                return item.value == newVal;
            });
            if (agencyValue > -1) {
                this.ReportingEntity.AgencyName = this.AgencyList[agencyValue].label;
            } else {
                this.ReportingEntity.AgencyName = "";
            }
        },
        GetReportingEntityRequestWithTaskDetails() {
            var inputObj = {
                id: parseInt(this.id),
                isEdit: this.IsEdit,
            };
            this.$store
                .dispatch("reportingEntity/GetReportingEntityRequestWithTaskDetails",inputObj)
                .then((res) => {
                this.ReportingEntity.LegalEntity = res.data.LegalEntity;
                this.EntityChange(false);
                this.ReportingEntity.Agency = res.data.Agency;
                this.ReportingEntity.Location = res.data.Location;
                this.ReportingEntity.Department = res.data.Department;
                this.ReportingEntity.SuggestedEntity = res.data.SuggestedEntity;
                this.ReportingEntity.HFMEntity = res.data.HFMEntity;
                this.ReportingEntity.IsMediaAssociated = res.data.IsMediaAssociated;
                this.ReportingEntity.IsMediaOfficeSetUpInMO = res.data.IsMediaOfficeSetUpInMO;
                this.ReportingEntity.IsRequiredInReach = res.data.IsRequiredInReach;
                this.ReportingEntity.IsChangeInReportingEntity = res.data.IsChangeInReportingEntity;
                this.ReportingEntity.AlternateSubsetsOrRollups = res.data.AlternateSubsetsOrRollups
                this.ReportingEntity.CurrentHFMEntity = res.data.CurrentHFMEntity;
                this.ReportingEntity.ExistingRollupsToRemove = res.data.ExistingRollupsToRemove;
                this.ReportingEntity.Status = res.data.Status;
                })
                .catch((err) => {
                if (err.response && err.response.status == 403) {
                    this.$router.push({
                    name: "error",
                    params: {
                        message: "UnAuthorized"
                    },
                    });
                }
                else{
                    this.Error = true;
                    alert(err);
                }
                });
        },
        SetDirty(propertyName) {
            this.$v.ReportingEntity[propertyName].$touch();

        },
        ResetDirty(propertyName) {
            this.$v.ReportingEntity[propertyName].$reset();
        },
        Next() {
            this.$parent.$emit("stepChanged", this.$route.meta.tabIndex);
            if (this.id) {
                this.$router.push({
                    name: "Reporting Info",
                    params: {
                        id: this.id,
                        isDraft: this.isDraft
                    }
                });
            } else {
                this.$router.push({
                    name: "Reporting Info"
                });
            }
        },
        Cancel() {
            this.$router.push("/ReportingEntity");
        },
        updateSuggestedEntity() {
            const { LegalEntity, Location, Department } = this.ReportingEntity;
            if (LegalEntity && Location && Department) {
                this.ReportingEntity.SuggestedEntity = `${LegalEntity}-${Location}-${Department}`;
            } else {
                this.ReportingEntity.SuggestedEntity = "";
            }
        }
    },
    watch: {
        "ReportingEntity.Department": function () {
            this.updateSuggestedEntity();
        },
        "ReportingEntity.Location": function () {
            this.updateSuggestedEntity();
        },
        "ReportingEntity.LegalEntity": function (val, newVal) {
            if(val && newVal != null) {
                this.EntityChange(true);
            } else {
                this.EntityChange(false);
            }
            let entity = this.EntityList.findIndex((item) => {
                return item.value == val;
            });
            if (entity > -1) {
                this.ReportingEntity.EntityName = this.EntityList[entity].label;
            } else {
                this.ReportingEntity.EntityName = "";
            }
        },
        "ReportingEntity.EntityName": function () {
            this.updateSuggestedEntity();
        },
        "ReportingEntity.Agency": function (val) {
            this.UpdateAgencyName(val);
        },
    },
}
</script>
